var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-left"},[_c('h1',{staticClass:"level-item is-size-3 has-text-weight-medium"},[_vm._v("devfinder")])])}]

export { render, staticRenderFns }